import FuseSvgIcon from "@fuse/core/FuseSvgIcon";

/** Estado vazio da lista de auditoria (sem eventos ou sem resultados para o filtro). */
export default function EstadoVazioAuditoria({ temFiltro }: { readonly temFiltro: boolean }) {
	return (
		<div className="flex min-h-[220px] flex-col items-center justify-center gap-3 rounded-md border border-dashed border-border bg-muted/20 px-4 py-8 text-center">
			<div className="flex items-center justify-center text-primary">
				<FuseSvgIcon size={32}>{temFiltro ? "lucide:search-x" : "lucide:scroll-text"}</FuseSvgIcon>
			</div>

			<div className="max-w-sm">
				<h3 className="text-md font-bold text-foreground">
					{temFiltro ? "Nenhum evento encontrado" : "Nenhum evento de auditoria"}
				</h3>
				<p className="mt-1 text-md leading-5 text-muted-foreground">
					{temFiltro
						? "Ajuste o tipo ou o intervalo de datas do filtro."
						: "Este grupo ainda não possui histórico de alterações."}
				</p>
			</div>
		</div>
	);
}
